export const TEXT_EDITOR_TYPE = {
  tinymce: 'tinymce',
  richSlate: 'richSlate',
};
